// Lista de países soportados en los cotizadores (públicos y privados).
// Un solo origen para todos los formularios: QuoteForm, CompactQuoteForm,
// CotizadorPublico, LandingQuote y EmbedCotizador.
// El backend (quoteRunner.js) filtra carriers por meta.international === true
// cuando la ruta es internacional (destCountry !== "México"), así que solo los
// carriers con capacidad internacional (DHL, FedEx, UPS, Estafeta, J&T, BHGC)
// aparecen en cotizaciones internacionales.
export const COUNTRIES = [
  "México", "Estados Unidos", "Canadá", "España", "Colombia", "Argentina",
  "Brasil", "Perú", "Chile", "Guatemala", "Cuba", "Hong Kong", "China",
  "Japón", "Singapur", "Corea del Sur", "Tailandia", "Alemania", "Francia",
  "Italia", "Reino Unido", "Países Bajos", "Australia", "India"
];